import { useCallback } from 'react';
import { useGetStreamData } from '../useGetStreamData';

export const useUpdateGoalInfo = () => {
	const { getStreamData } = useGetStreamData();

	const updateGoalInfo = useCallback(
		(prevState, stream) => {
			const goal = { ...prevState.goal };
			if (stream['/brain/destination']) {
				const dst = JSON.parse(getStreamData(stream, '/brain/destination'));
				goal.dst_mode = dst.dst_mode;
				if (dst.dst_mode === 1) {
					goal.dst_list = dst.destination;
				}
			}
			return goal;
		},
		[getStreamData],
	);

	return { updateGoalInfo };
};
